import { render, staticRenderFns } from "./OffersEditComponent.vue?vue&type=template&id=fadfcd84"
import script from "./OffersEditComponent.vue?vue&type=script&lang=js"
export * from "./OffersEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports